export const pathImages = "https://navalmotor.com/mediaserver/web/"
// export const pathImages = ""


// "homepage": "https://www.navalmotor.com/baifa",